import Image1 from '../../assets/images/about-us-hero.jpeg';

export const AboutContent = {
    heroBreadCrumb: {
        image: Image1,
        header: 'DELIVERING SUSTAINED GROWTH',
        description: 'We are diligently and sustainably achieving excellence in all that we do'
    },
    paragraph1: {
        header: "RAYKOS Overview",
        description: "Founded in 2023 by Mr. R. Siva Rama Krishna. RAYKOS Pharma was born of a vision."
    },
    paragraph2: {
        header: "Code of Conduct",
        description: "At RAYKOS, we maintain the highest standards of integrity and ethics across all operations. Our comprehensive Code of Conduct ensures transparency, accountability, regulatory compliance, and responsible business practices with all stakeholders including employees, partners, and patients."
    },
    paragraph3: {
        header: "Core Team",
        description: "Our experienced team is dedicated to providing access to affordable and innovative medicines that address critical unmet medical needs. With expertise spanning research, manufacturing, and distribution, we drive excellence across all operations."
    },
    paragraph4: {
        header: "Continuous Innovation",
        description: "We encourage a culture of innovation and our team works relentlessly to fulfill our promises to patients through innovative thinking, persistence, and passion for making the world a healthier place."
    },
    contentBlock1: {
        header: 'Our Promises',
        description: 'At RAYKOS, we make several promises to our customers and stakeholders, ensuring our dedication to excellence and customer satisfaction.',
        items: [
            {
                iconClass: 'fas fa-medal',
                header: 'Uncompromising Quality',
                description: 'We strive for excellence in every aspect of our operations, adhering to the highest quality standards to deliver safe and effective pharmaceutical products.'
            },
            {
                iconClass: 'fas fa-lightbulb',
                header: 'Innovation and Advancement',
                description: 'We are committed to driving innovation, constantly seeking new solutions, and advancing healthcare through cutting-edge research and development.'
            },
            {
                iconClass: 'fas fa-users',
                header: 'Customer-Centric Approach',
                description: 'We prioritize our customers needs, providing exceptional service, personalized support, and tailored solutions to meet their requirements.'
            },
            {
                iconClass: 'fas fa-globe',
                header: 'Global Accessibility',
                description: 'We are dedicated to ensuring global accessibility to our life-saving medications, reaching patients in need across borders and geographies.'
            }
        ]
    },
    contentBlock2: {
        header: 'Our Principles',
        description: 'Our principles guide our decision-making and define our company culture, ensuring ethical and responsible practices.',
        items: [
            {
                iconClass: 'fas fa-flask',
                header: 'Scientific Rigor',
                description: 'We uphold the highest scientific standards, conducting thorough research and development to ensure the efficacy and safety of our products.'
            },
            {
                iconClass: 'fas fa-leaf',
                header: 'Sustainability',
                description: 'We are committed to sustainable practices, minimizing our environmental impact, and contributing to the well-being of future generations.'
            },
            {
                iconClass: 'fas fa-handshake',
                header: 'Ethical Conduct',
                description: 'We conduct our business with integrity, honesty, and ethical practices, fostering trust among our stakeholders and society.'
            },
            {
                iconClass: 'fas fa-users',
                header: 'Leadership and Collaboration',
                description: 'We believe in fostering leadership and collaboration, both within our organization and with external partners, to drive positive change in the pharmaceutical industry.'
            }
        ]
    },
    contentBlock3: {
        header: 'Our Values',
        description: 'Our core values shape our behavior, drive our decisions, and define our company culture.',
        items: [
            {
                iconClass: 'fas fa-shield-alt',
                header: 'Integrity',
                description: 'We conduct our business with honesty, transparency, and ethical practices, fostering trust among our stakeholders.'
            },
            {
                iconClass: 'fas fa-hands-helping',
                header: 'Collaboration',
                description: 'We believe in the power of collaboration and teamwork, fostering partnerships to achieve shared goals and deliver impactful pharmaceutical solutions.'
            },
            {
                iconClass: 'fas fa-trophy',
                header: 'Excellence',
                description: 'We strive for excellence in all our endeavors, continuously improving and delivering high-quality products and services.'
            },
            {
                iconClass: 'fas fa-bolt',
                header: 'Empowerment',
                description: 'We empower our employees, providing them with opportunities for growth, creativity, and professional development.'
            }
        ]
    },
}